import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Style from './MobileEditSelect.module.scss';

const MobileEditSelect = ({
  handleSelectAll,
  isMobileEditActive,
  mobileCheckedCount,
  setCheckedItems,
  setIsMobileEditActive,
  watchlistCount,
}) => (
  <div className={classNames([Style.mobileEditContainer, isMobileEditActive && Style.editActive])}>
    {watchlistCount === mobileCheckedCount ? (
      <span className={Style.mobileSelectButton} onClick={() => setCheckedItems(() => [])}>
        Deselect All
      </span>
    ) : (
      <span className={Style.mobileSelectButton} onClick={handleSelectAll}>
        Select All
      </span>
    )}
    <span
      className={Style.mobileEditButton}
      onClick={() => setIsMobileEditActive(!isMobileEditActive)}
    >
      {isMobileEditActive ? 'Cancel' : 'Edit'}
    </span>
  </div>
);

MobileEditSelect.propTypes = {
  handleSelectAll: PropTypes.func,
  isMobileEditActive: PropTypes.bool,
  mobileCheckedCount: PropTypes.number,
  setCheckedItems: PropTypes.func,
  setIsMobileEditActive: PropTypes.func,
  watchlistCount: PropTypes.number,
};

export default MobileEditSelect;
